import script from "./MapParties.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapParties.vue?vue&type=script&setup=true&lang=ts"

import "./MapParties.vue?vue&type=style&index=0&id=73d46584&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d46584"]])

export default __exports__